<template>
  <aside 
    class="ui-lightbox" 
    :for="name"
    v-bind:class="{ 'video__pause': name.indexOf('lightboxVideo') > -1 }"
    v-show="$root.$data.lightboxToggled === name"
    @mousedown="$root.lightboxClick($event)"
  >
    <slot>
    </slot>
  </aside>
</template>
<script>
export default {
  props: [
    'name',
  ],
};
</script>
